import { gql } from 'urql';
import { PRODUCT } from '../client';
import { GMarkItemsAsBulkPickedMutation } from '../types/generated';

export const MARK_ITEMS_AS_BULK_PICKED = gql<GMarkItemsAsBulkPickedMutation>`
  mutation ${PRODUCT}MarkItemsAsBulkPicked($input: MarkItemsAsBulkPickedMutationInput!) {
    markItemsAsBulkPicked(input: $input) {
      success
      userErrors {
        message
        path
      }
    }
  }
`;
